import moment from 'moment-timezone';
import accounting from 'accounting';

// Giới hạn kích thước ảnh được phép tải lên.
//
// Vì sao chặn theo ĐỘ PHÂN GIẢI chứ không theo dung lượng: ngày 07/09/2026
// trang nhiệm vụ của rinhqua.com sập tab trên điện thoại vì ảnh nhiệm vụ là
// 6250x6250. Tệp chỉ nặng 899KB nên mọi ngưỡng dung lượng hợp lý đều cho lọt,
// nhưng trình duyệt phải giải nén thành bitmap 6250*6250*4 = ~149MB mỗi tấm;
// danh sách 10 nhiệm vụ ngốn ~1.5GB và bị hệ điều hành giết tab. Đo trên chính
// ảnh của hệ thống: tấm 899KB tốn 149MB RAM, còn tấm 4141KB (3000x1520) chỉ
// tốn 17MB - dung lượng không nói lên được gì.
export const IMAGE_MAX_EDGE = 4000; // cạnh dài nhất, tính bằng điểm ảnh
export const IMAGE_MAX_PIXELS = 16000000; // ~16 triệu điểm ảnh
export const IMAGE_MAX_FILE_SIZE = 8 * 1024 * 1024; // 8MB, lớp phụ chặn tệp khổng lồ

// Đọc kích thước thật của ảnh ngay trên trình duyệt, trước khi gửi lên máy chủ.
export const readImageSize = file =>
  new Promise(resolve => {
    const objectUrl = URL.createObjectURL(file);
    const img = new Image();

    img.onload = () => {
      URL.revokeObjectURL(objectUrl);
      resolve({ width: img.naturalWidth, height: img.naturalHeight });
    };
    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      resolve(null); // không đọc được thì thôi, để máy chủ quyết
    };
    img.src = objectUrl;
  });

// Trả về chuỗi lỗi tiếng Việt nếu ảnh vượt giới hạn, null nếu hợp lệ.
export const validateImageDimensions = async file => {
  if (file?.size > IMAGE_MAX_FILE_SIZE) {
    return `Ảnh nặng ${(file.size / 1024 / 1024).toFixed(1)}MB, vượt giới hạn ${IMAGE_MAX_FILE_SIZE /
      1024 /
      1024}MB. Vui lòng nén ảnh trước khi tải lên.`;
  }

  const size = await readImageSize(file);
  if (!size || !size.width || !size.height) return null;

  const { width, height } = size;
  if (width > IMAGE_MAX_EDGE || height > IMAGE_MAX_EDGE || width * height > IMAGE_MAX_PIXELS) {
    return `Ảnh ${width}x${height} quá lớn (tối đa ${IMAGE_MAX_EDGE}x${IMAGE_MAX_EDGE}). Ảnh quá lớn làm treo trình duyệt của khách trên điện thoại. Vui lòng thu nhỏ ảnh trước khi tải lên.`;
  }

  return null;
};

export const isJsonString = str => {
  if (str) {
    try {
      return JSON.parse(str);
    } catch (e) {
      return null;
    }
  } else {
    return null;
  }
};

export function rangeDesc(start, end) {
  return Array(start - end + 1)
    .fill()
    .map((_, idx) => start - idx);
}

export const today = moment().tz('Asia/Ho_Chi_Minh').format('YYYY-MM-DD');

export const formatDate = (date, format = 'MM/DD/YYYY') => moment(date).format(format);

export const getInitFilerChart = () => ({
  startDate: new Date(formatDate(moment(new Date()).subtract(6, 'days').add(1, 'day'))),
  endDate: new Date(formatDate(moment(new Date()).add(1, 'day'))),
});

export const downloadFile = (file, name) => {
  const url = window.URL.createObjectURL(new Blob([file]));
  const link = document.createElement('a');

  link.href = url;
  link.setAttribute('download', `${name}.xlsx`);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const getDomainUrl = url => {
  const matchResult = url?.match(/^https?:\/\/([a-zA-Z0-9.-]+)\.com$/);
  if (matchResult && matchResult.length === 2) {
    return matchResult[1];
  }
};

export const getUrlWebsite = domain => {
  return 'https://' + domain + '.com';
};

export const isObjectNameInArray = (targetName, array, key) => array?.some(element => element[key] === targetName);

export const convertToTitleCase = str => {
  const words = str.split('_');
  const capitalizedWords = words.map(word => {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });
  const convertedStr = capitalizedWords.join(' ');
  return convertedStr;
};

export function formatNumber(value, decimal = 2) {
  return accounting.formatNumber(value, decimal, '').replace(/.00$/g, '');
}

export const SystemLogsText = {
  DELETE_CATEGORY_SUCCESS: 'Xoá danh mục thành công',
  UPDATE_COIN_SUCCESS: 'Bù/ trừ coin thành công',
  DELETE_MISSON_SUCCESS: 'Xoá nhiệm vụ thành công',
  CREATE_SHIP_ORDER_SUCCESS: 'Tạo đơn hàng đang giao thành công',
  CHANGE_STATUS_SUCCESS: 'Đổi trạng thái thành công',
  DELETE_ORDER_SUCCESS: 'Xoá đơn hàng thành công',
  CREATE_POST_SUCCESSFULLY: 'Tạo nội dung hệ thống thành công',
  UPDATE_POST_SUCCESSFULLY: 'Cập nhật nội dung hệ thống thành công',
  DELETE_POST_SUCCESSFULLY: 'Xoá nội dung hệ thống thành công',
  CREATE_PRODUCT_SUCCESS: 'Tạo sản phẩm thành công',
  UPDATE_PRODUCT_SUCCESS: 'Cập nhật sản phẩm thành công',
  DELETE_PRODUCT_SUCCESS: 'Xoá sản phẩm thành công',
  CHANGE_STATUS_DONE: 'Đổi trạng thái hoàn thành',
  CREATE_OR_UPDATE_BOOK_MARKER: 'Tạo/ cập nhật book marker thành công',
  DELETE_BOOK_MARKER: 'Xoá book marker thành công',
  CANCEL_SHIP_ORDER_SUCCESS: 'Huỷ đơn hàng đang giao thành cồng',
  UPDATE_STORE_ADDRESS_SUCCESS: 'Cập nhật địa chỉ kho hàng thành công',
  CREATE_STORE_ADDRESS_SUCCESS: 'Tạo địa chỉ kho hàng thành công',
  CREATE_CATEGORY_SUCCESS: 'Tạo danh mục thành công',
  UPDATE_CATEGORY_SUCCESS: 'Cập nhật danh mục thành công',
  UPDATE_MISSION_SUCCESS: 'Cập nhật nhiệm vụ thành công',
  CREATE_MISSON_SUCCESS: 'Tạo nhiệm vụ thành công',
};

export const getLogDetail = logData => {
  if (logData?.note) {
    // switch (logData?.note?.type) {
    //   case 'ADD_COIN':
    //     return `Cộng ${logData?.note?.amount} coin cho ${logData?.note?.username} thành công`;
    //   case 'SUBTRACT_COIN':
    //     return `Trừ ${logData?.note?.amount} coin cho ${logData?.note?.username} thành công`;

    //   default:
    //     return SystemLogsText[logData?.action];
    // }
    return logData?.note?.msg;
  }

  return SystemLogsText[logData?.action];
};
